export const RAPID_FIRE_ROUTES = {
  start: '/rapid-fire',
  detail: '/rapid-fire/detail',
  leaderboard: '/rapid-fire/leaderboard',
  answerSheet: '/rapid-fire/answer-sheet',
};
